<template>
  <div id="app">
    <router-view />
    <el-dialog
      title="系统消息"
      :visible.sync="dialogVisible"
      width="70%"
    >
      <div>
        <div class="contentTitle">{{ content.esTitle }}</div>
        <div
          class="contentBody"
          v-html="content.esContent"
        ></div>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button
          type="primary"
          @click="dialogVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/api/api.js"
export default {
  name: 'App',
  data() {
    return {
      dialogVisible: false,
      content: {},
    }
  },
  created() {
    loadMessage();

    var inter = null;
    let that = this;
    function loadMessage() {
      if (!sessionStorage.getItem("token")) return
      getNewMesage();
      if (inter !== null)
        clearInterval(inter);
      inter = setInterval(() => {
        getNewMesage()
      }, 5 * 60 * 1000)
    }
    function getNewMesage() {
      request.getURL('/api/message/new').then(async res => {
        console.log('我获取最新消息了！', res)
        if (res.data.success) {
          let idx = 0;
          let seInd = setInterval(() => {
            if (idx < res.data.result.length) {
              const item = res.data.result[idx];
              let sendTime = new Date(item.esSendTime).getTime();
              let now = Date.now();
              if (sendTime >= now) {
                // 已经通知过的不重复通知
                let message = localStorage.getItem('messageIds') || '';
                if (message.indexOf(item.id) == -1) {
                  that.content = item;
                  that.dialogVisible = true;
                  message += item.id + ','
                  localStorage.setItem('messageIds', message);
                }
              }
              idx += 1;
            }
            else
              clearInterval(seInd);
          }, 300);
        }
      })
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: light;
}

.contentTitle {
  font-size: 20px;
  font-weight: bolder;
  margin-bottom: 10px;
  text-align: center;
}

.contentBody {
  white-space: pre-wrap;
  font-size: 16px;
  line-height: 1;
}

.contentBody p {
  /* margin-block-start: 0.5em !important; */
  margin-bottom: none;
}

a {
  text-decoration: none;
  color: black;
}

@import url("assets/text/text.css");

/*隐藏掉光标*/
/*div, span, p {*/
/*  caret-color: transparent;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue